export default __webpack_public_path__ + "static/media/Naomi.9d04ef8c.png";